"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductPanel = void 0;
exports.default = ProductPanelWrapper;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _componentUtilities = require("@ux/component-utilities");
var _enums = require("./enums");
var _reactMintl = require("@godaddy/react-mintl");
var _hamburger = _interopRequireDefault(require("@ux/icon/hamburger"));
var _chevronDown = _interopRequireDefault(require("@ux/icon/chevron-down"));
var _parentPanel = _interopRequireDefault(require("./parent-panel"));
var _childPanel = _interopRequireDefault(require("./child-panel"));
var _x = _interopRequireDefault(require("@ux/icon/x"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
class ProductPanel extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = _objectSpread(_objectSpread({}, this.state), {}, {
      selectedParent: null,
      showChildPanel: false,
      open: false,
      runway: false,
      hideOnScroll: false
    });
    this.control = /*#__PURE__*/_react.default.createRef();
    this.closeButton = /*#__PURE__*/_react.default.createRef();
    this.setFocusToClose = this.setFocusToClose.bind(this);
    this.close = this.close.bind(this);
    this.goToParentMenu = this.goToParentMenu.bind(this);
    this.setSelected = this.setSelected.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleForwardTab = this.handleForwardTab.bind(this);
    this.handleBackwardTab = this.handleBackwardTab.bind(this);
    this.handleArrowDown = this.handleArrowDown.bind(this);
    this.handleArrowUp = this.handleArrowUp.bind(this);
    this.killRunway = this.killRunway.bind(this);
    this.compareDivs = this.compareDivs.bind(this);
  }

  /**
   * Remove the eventListeners.
   *
   * @api private
   */
  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      state
    } = this;
    const {
      open
    } = state;
    if (prevState.open !== open) {
      if (typeof document !== 'undefined') {
        const html = this.html = this.target || document.documentElement;
        html.className = (0, _classnames.default)(html.className, this.mobileSafariClass);
        html.classList[open ? 'add' : 'remove']('product-flyout-open');
      }
    }
    if ((0, _componentUtilities.isMobile)(this.props.breakpoint)) {
      let parentNeedsRunway = false;
      let childNeedsRunway = false;
      if (this.parentPanel) {
        parentNeedsRunway = this.compareDivs(this.parentPanel.outerDiv, this.parentPanel.innerDiv);
      } else if (this.childPanel) {
        childNeedsRunway = this.compareDivs(this.childPanel.outerDiv, this.childPanel.innerDiv);
      }
      if ((childNeedsRunway || parentNeedsRunway) && !state.runway && !state.hideOnScroll) {
        this.setState({
          runway: true
        });
      } else if (!state.open && state.runway) {
        this.setState({
          runway: false
        });
      }
    }
  }
  componentDidMount() {
    if (typeof document !== 'undefined') {
      const userAgent = window.navigator.userAgent;
      const iOS = userAgent.match(/iPhone|iPad/i); // iPad and iPhone user agent for Safari
      const mobileRegExp = /(iPad|iPhone|CriOS).*WebKit(?:(?!(FxiOS|OPiOS)).)*$/;
      this.mobileSafariClass = mobileRegExp.test(userAgent) ? `mobile-safari-${iOS[0].toLowerCase()}` : '';
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }

  /**
   * Compare the heights of two div references.
   * @param  {Element} outer Ref to a div
   * @param  {Element} inner Ref to a div
   * @returns {Boolean} True if inner height > outer height
   */
  compareDivs(outer, inner) {
    if (outer && inner) {
      const outerDivHeight = outer.clientHeight;
      const innerDivHeight = inner.clientHeight;
      return innerDivHeight > outerDivHeight;
    }
    return false;
  }

  /**
   * get rid of the runway
   *
   * @private
   */
  killRunway() {
    if (!this.state.runway) {
      return;
    }
    this.setState({
      runway: false,
      hideOnScroll: true
    });
  }

  /**
   * close the menu by setting state.open to be false
   *
   * @private
   */
  close() {
    this.setState({
      open: false,
      showChildPanel: false,
      selectedParent: null
    }, () => this.control.current && this.control.current.focus());
  }

  /**
   * click function to set open/close state of menu
   *
   * @private
   */
  toggleOpen() {
    const {
      open
    } = this.state;
    this.setState({
      open: !open
    });
    this.closeButton.current.focus();
  }

  /**
   * Handle the Tab keydown. Do not allow tabbing in background and set focus.
   * @param {React.KeyboardEvent} e the event object sent from the browser
   *
   * @private
   */
  handleForwardTab(e) {
    const activePanel = this.childPanel ? this.childPanel : this.parentPanel;
    e.preventDefault();
    activePanel.focusNext();
  }

  /**
   * Handle the shift + Tab keydown. Do not allow tabbing in background and set focus.
   * @param {React.KeyboardEvent} e the event object sent from the browser
   *
   * @private
   */
  handleBackwardTab(e) {
    const activePanel = this.childPanel ? this.childPanel : this.parentPanel;
    e.preventDefault();
    activePanel.focusPrevious();
  }

  /**
   * Handle the ArrowDown keydown. Do not allow tabbing in background and set focus.
   * @param {React.KeyboardEvent} e the event object sent from the browser
   *
   * @private
   */
  handleArrowDown(e) {
    const activePanel = this.childPanel ? this.childPanel : this.parentPanel;
    e.preventDefault();
    activePanel.focusNext();
  }

  /**
    * Handle the ArrowUp keydown. Do not allow tabbing in background and set focus.
    * @param {React.KeyboardEvent} e the event object sent from the browser
    *
    * @private
    */
  handleArrowUp(e) {
    const activePanel = this.childPanel ? this.childPanel : this.parentPanel;
    e.preventDefault();
    activePanel.focusPrevious();
  }

  /**
   * Listen for the ESC and Tab key events.
   * @param {React.KeyboardEvent} e the event object sent from the browser
   * @private
   */
  handleKeyDown(e) {
    if (e.key && this.state.open) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        this.close();
      }
      if (e.key === 'Tab') {
        e.shiftKey ? this.handleBackwardTab(e) : this.handleForwardTab(e);
      }
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        this.handleArrowDown(e);
      }
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        this.handleArrowUp(e);
      }
    }
  }

  /**
   * Set which parent is currently selected
   * @param {Object} item The parent nav item and its properties
   */
  setSelected(item) {
    this.setState({
      selectedParent: item,
      showChildPanel: true,
      hideOnScroll: false
    });
  }

  /**
   * click function to go back to the parent menu
   *
   * @private
   */
  goToParentMenu() {
    this.setState({
      showChildPanel: false,
      hideOnScroll: false
    });
  }

  /**
   * change focus to exit "x"
   *
   * @api private
   */

  setFocusToClose() {
    this.closeButton.current.focus();
  }

  /**
   * Render translucent background behind the navigation menu
   *
   * @private
   *
   * @returns {React.ReactElement} div for the background
   */
  renderBackground() {
    if (!this.state.open) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      onClick: this.close,
      className: "product-panel-bkg",
      role: "presentation"
    });
  }

  /**
   * Render all panels containing children
   * @param  {Object[]} nav Array of child nav items
   * @param  {String} className Class to add to the child panel div
   * @returns {React.ReactElement[]} Array of child panels
   */
  renderChildPanels(nav, className) {
    const {
      state,
      props
    } = this;
    const panels = [];
    const {
      selectedParent
    } = state;
    const {
      id
    } = selectedParent || {};
    nav.forEach(navItem => {
      if (navItem.children && !navItem.onlyallproducts) {
        const matchingId = id && id === navItem.id;
        const open = state.showChildPanel && matchingId;
        panels.push(/*#__PURE__*/_react.default.createElement(_childPanel.default, {
          className: className,
          parent: navItem,
          onClose: this.close,
          onBack: this.goToParentMenu,
          open: open,
          tabIndex: open ? void 0 : -1,
          navigation: navItem.children,
          eidPrefix: props.eidPrefix,
          key: navItem.id,
          urlArgs: props.urlArgs,
          messages: props.messages,
          setFocusToClose: this.setFocusToClose,
          ref: r => {
            if (open) {
              this.childPanel = r;
            }
          },
          onScroll: this.killRunway
        }));
      }
    });
    return panels;
  }
  renderRunway() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('product-flyout-runway-container', {
        show: this.state.runway
      })
    }, /*#__PURE__*/_react.default.createElement(_chevronDown.default, {
      width: 15,
      height: 15
    }), /*#__PURE__*/_react.default.createElement(_chevronDown.default, {
      width: 15,
      height: 15
    }), /*#__PURE__*/_react.default.createElement(_chevronDown.default, {
      width: 15,
      height: 15
    }));
  }
  render() {
    const {
      props,
      state
    } = this;
    const parentPanelOpen = state.open && !state.showChildPanel;
    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(props.controlWrapperClass, 'product-flyout-btn-wrap', {
        ['is-open']: state.open
      })
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.productPanel
    }, productPanelTxt => /*#__PURE__*/_react.default.createElement("button", {
      "data-eid": "uxp.hyd.product_panel_control.button.click",
      onClick: this.toggleOpen,
      tabIndex: parentPanelOpen ? -1 : void 0,
      title: productPanelTxt,
      "aria-haspopup": true,
      "aria-expanded": state.open,
      className: "product-flyout-btn",
      ref: this.control
    }, props.control))), this.renderBackground(), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('product-flyout-menu', {
        open: state.open
      })
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.close
    }, closeTxt => /*#__PURE__*/_react.default.createElement("button", {
      className: "product-flyout-close",
      onClick: this.close,
      "aria-label": closeTxt,
      tabIndex: state.open ? void 0 : -1,
      ref: this.closeButton
    }, /*#__PURE__*/_react.default.createElement(_x.default, {
      width: 24,
      height: 24
    }))), /*#__PURE__*/_react.default.createElement(_parentPanel.default, (0, _extends2.default)({
      onClose: this.close,
      open: parentPanelOpen,
      tabIndex: parentPanelOpen ? void 0 : -1,
      onParentClick: this.setSelected,
      setFocusToClose: this.setFocusToClose,
      ref: r => {
        if (parentPanelOpen) {
          this.parentPanel = r;
        }
      },
      onScroll: this.killRunway
    }, props)), this.renderChildPanels(props.discoverNav, 'discover-child-panel'), this.renderChildPanels(props.productNav, 'product-child-panel'), this.renderRunway())));
  }
}
exports.ProductPanel = ProductPanel;
ProductPanel.propTypes = {
  productNav: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  discoverNav: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  bottomNav: _propTypes.default.arrayOf(_propTypes.default.object),
  breakpoint: _propTypes.default.string.isRequired,
  cartProps: _propTypes.default.object,
  control: _propTypes.default.element,
  controlWrapperClass: _propTypes.default.string,
  globalElements: _propTypes.default.oneOfType([_propTypes.default.shape({
    notifications: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.bool]),
    accountTray: _propTypes.default.bool,
    cart: _propTypes.default.bool,
    help: _propTypes.default.bool
  }), _propTypes.default.bool]),
  eidPrefix: _propTypes.default.string,
  isInGoCohort: _propTypes.default.bool,
  loggedIn: _propTypes.default.bool,
  market: _propTypes.default.string,
  messages: _propTypes.default.object.isRequired,
  onClose: _propTypes.default.func,
  onClick: _propTypes.default.func,
  urls: _propTypes.default.object.isRequired,
  urlArgs: _propTypes.default.object
};

/**
 * Default property values.
 *
 * @type {Object}
 * @public
 */
ProductPanel.defaultProps = {
  isInGoCohort: false,
  loggedIn: false,
  eidPrefix: 'uxp.hyd.product_panel_nav',
  market: 'en-US',
  control: /*#__PURE__*/_react.default.createElement(_hamburger.default, {
    width: 18,
    height: 18
  })
};
function ProductPanelWrapper(props) {
  const {
    breakpoint
  } = (0, _componentUtilities.useBreakpoints)(..._enums.breakpoints);
  return /*#__PURE__*/_react.default.createElement(ProductPanel, (0, _extends2.default)({
    breakpoint: breakpoint
  }, props));
}